import styled, { css } from 'styled-components';
import { Paragraph, Caption, Subtitle, Label as label } from '../../typographies';
import { PrimaryButton } from '../../button';
import { FontAddiWeightExtraBold } from '@addi/foundation/dist/web/fonts';
import { ColorAddiBlack, ColorAddiPrimaryHover, ColorAddiFontHint, ColorAddiFontAction, ColorAddiPrimaryActive, ColorAddiFontPrimary, } from '@addi/foundation/dist/web/colors';
import { FontAddiFamilyPrimaryName } from '@addi/foundation/dist/web/fonts';
import { SizeAddiFontXLarge } from '@addi/foundation/dist/web/sizes';
const highlightedText = css `
  color: ${ColorAddiPrimaryHover};
`;
const highlightedPayment = css `
  font-family: ${FontAddiFamilyPrimaryName} !important;
  color: ${ColorAddiPrimaryActive} !important;
  font-weight: ${FontAddiWeightExtraBold};
`;
//TODO: add this color to the ui foundation
const border = css `
  border-bottom: 1px solid ${ColorAddiFontHint};
`;
export const Term = styled(Caption) `
  margin: 0;
  font-size: ${SizeAddiFontXLarge};
  color: ${({ isSelected }) => (isSelected ? ColorAddiPrimaryHover : ColorAddiFontHint)};
`;
export const HeadContainer = styled.div `
  display: flex;
  width: 72px;
  padding: 8px 0 6px 0;
  flex-direction: column;
  align-items: center;
`;
export const PaymentNotice = styled(Caption) `
  display: flex;
  text-align: center;
  justify-content: center;
  color: ${({ isSelected }) => (isSelected ? ColorAddiFontAction : ColorAddiFontHint)};
`;
export const ContentRow = styled.div `
  display: flex;
  padding: 10px 0;
  justify-content: space-between;
  align-items: center;
  ${({ borderBottom }) => borderBottom && border};
  display: ${({ hidden }) => (hidden ? 'none' : 'flex')};
`;
export const ParaghraphGray = styled(Paragraph) `
  color: ${ColorAddiFontPrimary} !important;
  font-size: 14px;
  font-style: ${({ isItalic }) => (isItalic ? 'italic' : 'normal')};
`;
export const Label = styled(label) `
  display: flex;
  text-align: center;
  justify-content: center;
  font-style: italic;
`;
export const MonthlyPaymentLabel = styled(Label) `
  font-weight: 500;
  font-style: normal;
  ${highlightedText}
`;
export const BorderContainer = styled.div `
  background-color: ${ColorAddiPrimaryActive};
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;

  border-bottom-left-radius: -10px;
  border-bottom-right-radius: -10px;

  width: 100%;
  height: 3px;
`;
export const CurrencyContainer = styled(Subtitle) `
  margin: 0;
  color: ${({ regularColor }) => (regularColor ? ColorAddiBlack : ColorAddiFontPrimary)};
  ${({ highlighted }) => highlighted && highlightedPayment};
`;
export const ContentContainer = styled.div `
  box-shadow: 0px -3px 0px rgb(78 123 250);
  margin-top: -5px;
  padding: 0 16px 8px;
  border-radius: 10px;
`;
export const Button = styled(PrimaryButton) `
  width: 100%;
  margin: 25px 0;
`;
export const PromotionalTextContainer = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 18px;
`;
export const PromotionalTextParagraph = styled(Caption) `
  line-height: 18px;
  margin: 0;
`;
export const PromotionalTextIcon = styled.img `
  width: 22px;
  height: 21px;
  margin-right: 7px;
`;
//# sourceMappingURL=proposal-tabs.styled.js.map